/* eslint-disable react/button-has-type */
import React from 'react';
import { twMerge } from '@/utils';

interface IStandardButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  /** Ref for the button */
  buttonRef?: React.RefObject<HTMLButtonElement>;
  /** Button contents */
  children?: ReactChildren;
  /** Additional classes to apply to the button */
  className?: string;
  /** Button color */
  color?: ButtonColors;
  /** Is the button disabled? */
  disabled?: boolean;
  /** Aria label for the button */
  label?: string;
  /** Optional click handler */
  onClick?: (formData) => void;
  /** Should the button have an outline style? */
  outlineStyle?: boolean;
  /** Should the button be small? */
  small?: boolean;
  /** Button type */
  type?: 'button' | 'submit';
  /** Button variant */
  variant?: 'rounded-right';
}

/** Standard button component */
const StandardButton = React.forwardRef<HTMLButtonElement, IStandardButtonProps>(({
  buttonRef = null,
  children,
  className = '',
  color = 'purple',
  disabled = false,
  label = '',
  onClick = () => {},
  outlineStyle = false,
  small = false,
  type = 'button',
  variant,
  ...props
}, ref) => {
  const buttonClass = () => {
    const roundedRight = variant === 'rounded-right' ? 'rounded-right' : '';

    if (outlineStyle) return `btn--outline-${color} ${roundedRight}`;

    return `btn--${color} ${roundedRight}`;
  };

  return (
    <button
      ref={ref || buttonRef}
      aria-label={label}
      className={
        twMerge('btn', buttonClass(), className, small ? 'btn--sm' : '')
      }
      disabled={disabled}
      type={type}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  );
});

StandardButton.displayName = 'StandardButton';

export default StandardButton;
